/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Bright_Cod_ClapInputs */

const en_plum_bright_cod_clap = /** @type {(inputs: Plum_Bright_Cod_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-mail address of the employee`)
};

const de_plum_bright_cod_clap = /** @type {(inputs: Plum_Bright_Cod_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse des Mitarbeiters`)
};

/**
* | output |
* | --- |
* | "e-mail address of the employee" |
*
* @param {Plum_Bright_Cod_ClapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_bright_cod_clap = /** @type {((inputs?: Plum_Bright_Cod_ClapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Bright_Cod_ClapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_bright_cod_clap(inputs)
	return de_plum_bright_cod_clap(inputs)
});